var customRoute = function() {

	var objCustomRoute = {};

	var proposalID = window.location.pathname.split('/')[1].split(':')[1];

	// Turns a pending route into a real route.
	// This needs work.
	objCustomRoute.createRoute = function(pendingRouteID, proposalID, callback) {
		$('#decisions').mask('Processing');

		paramData = {
			routeID : pendingRouteID,
			proposalID : proposalID,
			decision : 'route'
		};

		$.ajax({
			type: 'POST',
			url: '/proposal:' + proposalID + '/customRoute.json',
			data: paramData,
			success: function(data) {
				console.log('Created Custom Route.');
				callback && callback();
			}
		});
	};

	objCustomRoute.rejectRoutes = function(proposalID, proposalStepActionID, pendingRouteID, callback) {
		$.ajax({
			type: 'DELETE',
			url: '/proposal:' + proposalID + '/customRoute.json',
			data: {
				'proposalID' : +proposalID,
				'proposalStepActionID' : +proposalStepActionID,
				'pendingRouteID': +pendingRouteID,
			},
			success: function() {
				// console.log('success');
				callback && callback();
			}
		});
	};

	objCustomRoute.rejectOthers = function(proposalId, currentStepId, callback) {
		params = {
			proposalId: proposalId,
			currentStepId: currentStepId,
			decision: 'reject-request'
		};

		$.ajax({
			url: '/admin/dashboard/resolveRequest.json',
			type: 'PUT',
			data: params,
			success: function(){
				callback && callback();
			}
		});
	};


	objCustomRoute.createPendingRoute = function(proposalID, currentStepID, committee, callback) {
		if (committee === undefined) {
			committee = 0;
		}

		var comment = $('#decision-comment').val();
		$.ajax({
			// async: false,
			type: 'POST',
			url: '/proposal:' + proposalID + '/pendingRoute.json',
			contentType: 'application/json',
			data: JSON.stringify({
				proposalID : +proposalID,
				originalStepID : +currentStepID,
				committeeID : +committee
			}),
			success: function(data) {

				if (+data.stepID > 0) {
					callback && callback(data);
				} else {
					$('#growls').notify('create', 'warning-template', {
						title: 'Warning',
						text: 'You have already created a pending route and ' +
							'cannot create another one. You can either ' +
							'modify your existing request or cancel it and ' +
							'start over.'
					});
					$('#decisions').unmask();
				}

			}
		});
	};

	objCustomRoute.deletePendingRoute = function(stepID, callback) {
		//console.log('Deleting Route: ' + stepID)
		$.ajax({
			type: 'DELETE',
			url: '/proposal:' + proposalID + '/pendingRoute.json',
			data: {stepID: stepID},
			success: function(data) {
				if (+data.success > 0) {
					proposalObject.ajaxTab('route');
					callback && callback();
				} else {
					$('#growls').notify('create', 'warning-template', {
						text: 'The data you are viewing is old and may have changed. Please refresh.'
					});
				}
			}
		});
	};

	objCustomRoute.getCommittee = function(callback) {
		var stepID = $('#route').find('.step').attr('id').replace('step-', '');
		$.ajax({
			type: 'GET',
			url: '/proposal:' + proposalID + '/pendingRouteCommittee.json?id=' + stepID,
			success: function(results) {
				callback && callback(results.committee);

			}
		});
	};

	objCustomRoute.launchPendingRoute = function() {
		//console.log('Launching Pending Route!');

		if($('#route ul.selected-role-types li').length === 0 &&
			$('#route ul.selected-roles li').length === 0 &&
			$('#route ul.selected-users li').length === 0) {

			// Step doesn't have users. DON'T LAUNCH!
			var dialog = objDialog.createBasicWarningDialog('cannot-launch-proposal-dialog', function(dialog, defaults) {

				$(dialog).append(
					'Your custom route is missing the required participants. ' +
					'Please check your route again and click the edit button ' +
					'to add one or more users to your custom route request.'
				);

				defaults.buttons = {
					'Ok': function() {
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});

		} else {

			objCustomRoute.getCommittee(function(committeeId) {

				var comment = $('#route-comment').val();
				$('#route').mask('Processing');
				var stepId = $('#route').find('.step').attr('id');
				var actionId = $('#' + stepId + '-customAction').val();
				$.ajax({
					type: 'PUT',
					url: '/proposal:' + proposalID + '/stepAction.json',
					contentType: 'application/json',
					data: JSON.stringify({
						proposalID: proposalID,
						userID: $('#user').val(),
						decision: 'request-route',
						currentStepId: $('#currentStepId').val(),
						agendaId: $('#agendaId').val(),
						proposalStepActionID : actionId, //$('#stepActionId').val(),
						addComment: 1,
						committeeId: committeeId,
						decisionComment: comment
					}),
					success: function() {
						proposalObject.ajaxTab('route');
						Backbone.trigger('form:stretch');
						Curriculog.Actions.log('proposal-route-submitted');
					},
					complete: function(data) {
						$('#route').unmask();
						console.log(data);
					}
				});
			});

		}
	};


	/**
	 *
	 *
	 */
	objCustomRoute.createDOMStep = function(stepID, callback) {
		//console.log('createDOMStep');

		// If there is no callback then we need to execute the ajax syncronously.
		var async = (typeof callback === 'function');

		$.ajax({
			type: 'GET',
			url: '/proposal:' + $('#proposalId').val() + '/pendingRoute.json',
			data: { id: stepID },
			async: async,
			success: function() {
				proposalObject.ajaxTab('route');
				callback && callback();
				approvalProcessObject.verticalStretch();
			}
		});
	};


	/**
	 * Object: updateDOMStep
	 * Purpose:
	 */
	objCustomRoute.updateDOMStep = function(stepIdSelector) {
		var stepId = stepIdSelector.split('-')[1];
		$.ajax({
			type: 'GET',
			url: '/proposal:' + proposalID + '/pendingRoute.json',
			data: { id: stepId },
			success: function(data) {
				if(data.customRoute === 2) {
					$('#growls').notify('create', 'warning-template', {
						text: 'The data you are viewing is old and may have changed. Please refresh.'
					});
				}
				else
				{
					proposalObject.ajaxTab('route');
					approvalProcessObject.verticalStretch();
				}
			}
		});
	};

	return objCustomRoute;
};